import React from "react";
import { Modal } from "react-bootstrap";
import alertModalStyles from "../../../../../Reusables/components/AlertModal/AlertModal.module.css";
import styles from "./RecipientsModal.module.css";
import CygnusGrid from "../../../../reusable_components/CygnusGrid/CygnusGrid";

interface Recipient {
  RecipientEmail: string;
  Sequence: number;
}

interface RecipientsModalProps {
  show: boolean;
  onHide: () => void;
  recipients: Recipient[];
}

const recipientColumnDefs = [
  {
    headerName: "Field Name",
    field: "FieldName",
    flex: 1,
    filter: false,
    sortable: false,
  },
  {
    headerName: "Email",
    field: "RecipientEmail",
    flex: 1,
    filter: false,
    sortable: false,
  },
  {
    headerName: "Sequence",
    field: "Sequence",
    width: 130,
    filter: false,
    sortable: false,
  },
];


const RecipientsModal: React.FC<RecipientsModalProps> = ({
  show,
  onHide,
  recipients,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      keyboard={false}
      dialogClassName={alertModalStyles.dialog}
      contentClassName={alertModalStyles.content}
      backdropClassName={alertModalStyles.backdrop}
      aria-labelledby="recipients-modal"
    >
      <Modal.Header closeButton className={alertModalStyles.header}>
        <Modal.Title className={alertModalStyles.message}>
          Recipient Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={alertModalStyles.body}>
        <div className={styles.gridWrapper}>
          <CygnusGrid
            columnDefs={recipientColumnDefs}
            fetchData={async () => ({
              records: recipients,
              totalCount: recipients.length,
            })}
            cachedData={recipients}
            rowModelType="clientSide"
            dataIdentifier="Sequence"
            rowSelection={undefined}
            floatingFilters={false}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RecipientsModal;